import React, { ReactNode } from 'react';
import { AutomationTemplateCategory } from './AutomationTemplateCategory';
import { AutomationTemplateContainer } from './AutomationTemplateContainer';
import {
  AutomationTemplateChannel,
  AutomationTemplateDefinition,
  AUTOMATION_TEMPLATES_BY_CATEGORY,
} from './Templates/TemplateDefinitions';

export const AutomationTemplates = ({
  className,
  heading,
  footer,
  setActiveTemplate,
  templateChannel,
  activeStep,
  setActiveStep,
  outboundAutomationParams,
  closeModal,
}: {
  className: string;
  heading?: ReactNode;
  footer?: ReactNode;
  templateChannel: AutomationTemplateChannel;
  setActiveTemplate: (template: {
    template: AutomationTemplateDefinition;
    channel: AutomationTemplateChannel;
  }) => void;
  activeStep: number;
  setActiveStep: (step: number) => void;
  outboundAutomationParams?: any;
  closeModal?: () => void;
}) => {
  return (
    <AutomationTemplateContainer.Provider>
      <div className={className}>
        {heading ? heading : null}
        {AUTOMATION_TEMPLATES_BY_CATEGORY.map(category => (
          <AutomationTemplateCategory
            key={category.categoryName}
            category={category}
            setActiveTemplate={setActiveTemplate}
            templateChannel={templateChannel}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            outboundAutomationParams={outboundAutomationParams}
            closeModal={closeModal}
          />
        ))}
        {footer ? footer : null}
      </div>
    </AutomationTemplateContainer.Provider>
  );
};
